import React, { useState, useEffect } from 'react';
import { BRAND_NAME } from '../constants';
import { Menu, X } from 'lucide-react';

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'METODOLOGÍA', id: 'methodology' },
    { name: 'TRACK RECORD', id: 'track-record' },
    { name: 'CONTACTO', id: 'contact' },
  ];

  const scrollToSection = (id: string) => {
    setMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${isScrolled ? 'bg-slate-950/95 border-slate-900 py-4' : 'bg-transparent border-transparent py-6'}`}>
      <div className="container mx-auto px-6 flex justify-between items-center">
        <div className="text-xl font-medium text-white tracking-widest uppercase">
          {BRAND_NAME}<span className="text-sage-400">.</span>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex gap-12 items-center">
          {navLinks.map((link) => (
            <button 
              key={link.name} 
              onClick={() => scrollToSection(link.id)}
              className="text-xs font-medium tracking-widest text-slate-400 hover:text-sage-400 transition-colors uppercase"
            >
              {link.name}
            </button>
          ))}
          <a 
            href="https://t.me/CarrionBET"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-2 bg-sage-400 hover:bg-sage-300 text-slate-950 text-xs font-bold tracking-widest rounded-none transition-colors"
          >
            ACCESO CLIENTES
          </a>
        </div>

        {/* Mobile Toggle */}
        <button 
          className="md:hidden text-white"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X strokeWidth={1} /> : <Menu strokeWidth={1} />}
        </button>

        {/* Mobile Menu Overlay */}
        {mobileMenuOpen && (
          <div className="absolute top-full left-0 right-0 bg-slate-950 border-b border-slate-900 p-8 flex flex-col gap-6 shadow-2xl md:hidden">
            {navLinks.map((link) => (
              <button 
                key={link.name} 
                onClick={() => scrollToSection(link.id)}
                className="text-left text-sm font-medium tracking-widest text-slate-300 hover:text-sage-400 uppercase py-2 border-b border-slate-900"
              >
                {link.name}
              </button>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;